import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '登录',
      component: resolve => require(['../view/Login'], resolve),
    },
    {
      path: '/homepage',
      name: '首页',
      component: resolve => require(['../view/Homepage'], resolve),
    },
    {
      path: '/wordDetailsPage',
      name: '首页',
      component: resolve => require(['../view/wordDetailsPage'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js